// src/components/MovieCard.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
    addToWatchlist,
    removeFromWatchlist,
    isMovieInWatchlist,
    addToLikedlist,
    removeFromLikedlist,
    isMovieInLikedlist,
} from "../services/firebase";
import { FaRegHeart, FaHeart, FaRegBookmark, FaBookmark } from "react-icons/fa";
import "./MovieCard.scss";

const MovieCard = ({ movie }) => {
    const { user } = useAuth();
    const [isInWatchlist, setIsInWatchlist] = useState(false);
    const [isInLikedlist, setIsInLikedlist] = useState(false);

    useEffect(() => {
        // Check if the movie is in the user's watchlist
        const checkWatchlistStatus = async () => {
            if (user) {
                const movieInWatchlist = await isMovieInWatchlist(
                    user.uid,
                    movie.id
                );
                setIsInWatchlist(movieInWatchlist);
            }
        };

        // Check if the movie is in the user's likedlist
        const checkLikedlistStatus = async () => {
            if (user) {
                const movieInLikedlist = await isMovieInLikedlist(
                    user.uid,
                    movie.id
                );
                setIsInLikedlist(movieInLikedlist);
            }
        };

        checkWatchlistStatus();
        checkLikedlistStatus();
    }, [user, movie.id]);

    const handleAddToWatchlist = async () => {
        if (user) {
            await addToWatchlist(user.uid, movie);
            setIsInWatchlist(true);
        }
    };

    const handleRemoveFromWatchlist = async () => {
        if (user) {
            await removeFromWatchlist(user.uid, movie.id);
            setIsInWatchlist(false);
        }
    };

    const handleAddToLikedlist = async () => {
        if (user) {
            await addToLikedlist(user.uid, movie);
            setIsInLikedlist(true);
        }
    };

    const handleRemoveFromLikedlist = async () => {
        if (user) {
            await removeFromLikedlist(user.uid, movie.id);
            setIsInLikedlist(false);
        }
    };

    return (
        <div className="movie_card">
            <Link to={`/movie/${movie.id}`}>
                <img
                    src={`https://image.tmdb.org/t/p/w300/${movie.poster_path}`}
                    alt={movie.title}
                />
            </Link>
            <div className="movie_card_details">
                <div className="movie_card_text">
                    <h3>{movie.title}</h3>
                </div>
                <div className="movie_card_icons">
                    {user && (
                        <div className="save_lists">
                            {isInWatchlist ? (
                                <button
                                    title="Remove from Watchlist"
                                    onClick={handleRemoveFromWatchlist}
                                >
                                    <FaBookmark />
                                </button>
                            ) : (
                                <button
                                    title="Add to Watchlist"
                                    onClick={handleAddToWatchlist}
                                >
                                    <FaRegBookmark />
                                </button>
                            )}
                            {isInLikedlist ? (
                                <button
                                    title="Remove from Likedlist"
                                    onClick={handleRemoveFromLikedlist}
                                >
                                    <FaHeart />
                                </button>
                            ) : (
                                <button
                                    title="Add to Likedlist"
                                    onClick={handleAddToLikedlist}
                                >
                                    <FaRegHeart />
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MovieCard;
